import React, { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';
import { motion } from 'framer-motion';
import useStyles from '../../Carousel.style';

export const CarouselPaginationProgress = ({
  paginationProgressAriaLabel,
}: {
  paginationProgressAriaLabel: (progress: number, progressPercent: number) => string;
}) => {
  const swiper = useSwiper();
  const [progress, setProgress] = useState(0);
  const c = useStyles({});

  useEffect(() => {
    if (!swiper) return;

    const updateProgress = () => {
      setProgress(Math.min(1, Math.max(0, swiper.progress)));
    };

    updateProgress();

    swiper.on("progress", updateProgress);
    swiper.on("slideChange", updateProgress);
    swiper.on("resize", updateProgress);

    return () => {
      swiper.off("progress", updateProgress);
      swiper.off("slideChange", updateProgress);
      swiper.off("resize", updateProgress);
    };
  }, [swiper]);

  const progressPercent = progress * 100;

  return (
    <div
      className={c.paginationProgress}
      role="progressbar"
      aria-label={paginationProgressAriaLabel(progress, Math.round(progressPercent))}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progressPercent)}
    >
      <motion.div
        className={c.paginationProgressFill}
        animate={{ width: `${progressPercent}%` }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      />
    </div>
  );
};
